import { Expose, Type } from 'class-transformer'
import { BookCardType } from './BookCardType'

export class BookShelfResponse {
  @Expose() page: number

  @Expose({ name: 'data' })
  @Type(() => BookCardType)
  myShelfs: BookCardType[]

  @Expose()
  total: number
}
